import { useDispatch, useSelector } from 'react-redux';
import { roundnessCalculator } from '@/components/DesignSystem/AtomicComponents/util';
import { deviceWidth } from '@/utils/deviceWidth';
import { handleB2bCart } from '@/utils/handleB2bCart';
import { MAX_MOBILE_WIDTH } from '@/utils/constants';
import styles from './B2b.module.scss';

export const B2bRequestForQuoteDesktop = ({
  storeInfo,
  openRfqFormModal,
  product,
  toggleAuthModal,
  activeVariant = null,
}) => {
  const isMobile = deviceWidth <= MAX_MOBILE_WIDTH;
  const { userData } = useSelector((state) => ({
    userData: state.userReducer,
  }));
  const dispatch = useDispatch();

  const handleRequestForBtnClick = () => {
    if (!userData?.isLogin) {
      toggleAuthModal();
      return;
    } else {
      handleB2bCart(
        product,
        activeVariant,
        'ADD',
        activeVariant
          ? activeVariant?.b2b_pricing_info?.minimum_order_quantity
          : product?.b2b_pricing_info?.minimum_order_quantity
      );
      dispatch(openRfqFormModal());
    }
  };

  if (isMobile) return null;

  return (
    <div className={styles.b2bRequestForBtnContainer}>
      <button
        onClick={handleRequestForBtnClick}
        className={styles.btn}
        style={{
          backgroundColor: storeInfo?.theme?.colors?.primary_color,
          borderRadius: roundnessCalculator(storeInfo?.theme?.roundness),
        }}
      >
        Request For Quote
      </button>
    </div>
  );
};
